export default __webpack_public_path__ + "static/hanging sign-a85fb858824847a54a2068677abdf29f.png";